import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) return <Navigate to="/dang-nhap" state={{ from: location.pathname }} replace />;

  return <Outlet />;
}
